import React, { useState, useEffect } from "react";
import {
    Checkbox,
    makeStyles,
    Typography,
    Paper,
    Modal,
    Backdrop,
    Fade,
    Divider,
    InputAdornment,
    TextField,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
} from "@material-ui/core";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import UserService from "../../services/console_services/user";
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles({
    row: {
        backgroundColor: "white",
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalContent: {
        backgroundColor: "white",
        borderRadius: 8,
        padding: "16px",
        width: "30vw",
        height: "auto",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        outline: "none",
        overflowY: "auto",
        maxHeight: "90vh",
    },
});

export const UserPopup = ({ open, onClose, fetchUserData, user = null, selectedUser }) => {
    const classes = useStyles();
    const isEditMode = Boolean(user);

    const [formData, setFormData] = useState({
        Level: "",
        designation: "",
        Name: "",
        UserID: "",
    });
    useEffect(() => {
        if (selectedUser) {
            setFormData(selectedUser); // Prefill form with selected user data
        }
    }, [selectedUser]);

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isEditMode && user) {
            setFormData({
                Level: user.Level || "",
                designation: user.designation || "",
                Name: user.Name || "",
                UserID: user.UserID || "",
            });
        }
    }, [user, isEditMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.Name) { newErrors.Name = "Name is required.";}
        if (!formData.UserID) { newErrors.UserID = "User ID is required.";}
        if (!formData.designation) { newErrors.designation = "Designation is required.";}
        if (!formData.Level) {newErrors.Level = "Level is required.";}
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) {return;}

        if (isEditMode) {
            updateUserDetails(formData);
        } else {
            addUserDetails(formData);
        }
        onClose();
    };

    const addUserDetails = async (formData) => {
        const updatedData = {...formData, "accessUpdated":true };
        try {
            if (selectedUser) {
                // Update user logic
                await UserService.updateUser(updatedData);
            } else {
                // Add user logic
                await UserService.addUser(formData);
            }
            fetchUserData();
        } catch (error) {
            console.error("Error saving user details:", error);
        }
    };

    const updateUserDetails = async (formData) => {
        try {
            const response = await UserService.updateUser(user.id, formData);
            if (response?.data) {
                fetchUserData();
            }
        } catch (error) {
            console.error('Error updating user details:', error);
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <Paper className={classes.modalContent}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" gutterBottom>
                            {isEditMode ? "Edit User Details" : "Add User Details"}
                        </Typography>
                        <IconButton
                            onClick={onClose}
                            style={{ padding: 0 }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <TextField
                        label="Name"
                        name="Name"
                        value={formData.Name}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        error={!!errors.Name}
                        helperText={errors.Name}
                    />
                    <TextField
                        label="UserID"
                        name="UserID"
                        value={formData.UserID}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        error={!!errors.UserID}
                        helperText={errors.UserID}
                        type="email"
                        disabled={isEditMode} // Prevent editing UserID in edit mode
                    />
                    <TextField
                        label="Designation"
                        name="designation"
                        value={formData.designation}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        error={!!errors.designation}
                        helperText={errors.designation}
                    />
                    <FormControl
                        fullWidth
                        margin="normal"
                        error={!!errors.Level}
                    >
                        <InputLabel>Level</InputLabel>
                        <Select
                            name="Level"
                            value={formData.Level}
                            onChange={handleChange}
                            IconComponent={KeyboardArrowDownIcon}
                        >
                            <MenuItem value="L0">L0</MenuItem>
                            <MenuItem value="L1">L1</MenuItem>
                            <MenuItem value="L2">L2</MenuItem>
                            <MenuItem value="L3">L3</MenuItem>
                        </Select>
                        {errors.Level && (
                            <Typography variant="caption" color="error">
                                {errors.Level}
                            </Typography>
                        )}
                    </FormControl>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        fullWidth
                        style={{ marginTop: '30px' }}
                    >
                        {isEditMode ? "Update" : "Submit"}
                    </Button>
                </Paper>
            </Fade>
        </Modal>
    );
};
